import React from 'react';
import { IconButton } from '@material-ui/core';
import PlayCircleFilledWhiteRoundedIcon from '@material-ui/icons/PlayCircleFilledWhiteRounded';
import { CSSProperties } from '@material-ui/core/styles/withStyles';


interface PlayButtonProps {
  onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void,
  size?: number,
  style?: CSSProperties
}

const PlayButton: React.FC<PlayButtonProps> = ({
  size = 73,
  onClick,
  style
}) => (
  <IconButton
    color='secondary'
    onClick={onClick}
    style={style}
  >
    <div style={{ position: 'absolute', height: `${size * 0.6}px`, width: `${size * 0.6}px`, zIndex: 1, backgroundColor: '#fff', borderRadius: '50%' }} />
    <PlayCircleFilledWhiteRoundedIcon
      color='secondary'
      style={{ width: `${size}px`, height: `${size}px`, zIndex: 2 }}
      fontSize='large'
    />
  </IconButton>
);

export default PlayButton;
